/**
 * Секрет доверенного устройства.
 *
 * Сервер выдаёт его при входе по паролю (`LoginResponse.device_token`) и ждёт обратно в
 * `LoginRequest.device_token` при следующем входе. Смысл один: предохранитель «этот логин с любых
 * адресов» — 300 неудач в сутки — запирает аккаунт на сутки, когда чужой перебирает пароль с сотен
 * адресов. Для устройства, которое показало секрет, этот предохранитель не действует: сервер
 * узнаёт своего и пускает по паролю, как обычно. Пороги по паре «логин + адрес» остаются —
 * секрет не заменяет пароль.
 *
 * Живёт в `localStorage`, а не в cookie: он должен пережить выход из аккаунта (после выхода
 * человек входит снова с того же телефона — и это ровно тот случай, ради которого секрет
 * существует). Утечка секрета даёт нападающему только одно — обход предохранителя по логину при
 * известном пароле; пароль всё равно нужен.
 */
const KEY = 'tt:device-token';

function read(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    // Приватный Safari и блокировщики бросают исключение — считаем, что секрета нет.
    return null;
  }
}

function write(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    // Не сохранился — при следующем входе сервер выдаст новый.
  }
}

/** Секрет, который предъявляем при входе, или `null`, если устройство ещё незнакомое. */
export function deviceToken(): string | null {
  const value = read(KEY);
  return value !== null && value.length > 0 ? value : null;
}

/** Сервер выдал новый секрет — прежний (если был) больше не нужен. */
export function rememberDeviceToken(token: string | null | undefined): void {
  if (typeof token === 'string' && token.length > 0) write(KEY, token);
}
